export default "__VITE_ASSET__CqqKGG4I__"